import { StateSchema } from 'app/config/storeConfig/types';
import { TakeUpReservationModalSchema } from '../types';

export const getTakeUpReservationState = (state: StateSchema): TakeUpReservationModalSchema => state.takeUpReservationModal;
